import { withInstall } from '../../../utils/with-install'
import ScatterLayer from './ScatterLayer.vue'

export const ElAmapLocaScatter = withInstall(ScatterLayer)
export default ElAmapLocaScatter
